/**
 * Shadow dom related helpers.
 */
export default class ShadowDom {
  /**
   * Check if given element is currently mounted in the dom. No matter if it is directly in
   * the main document or somewhere within a shadow dom document fragment.
   */
  static isInDocument (element: Node): boolean {
    let currentElement = element;
    while (currentElement && currentElement.parentNode) {
      if (currentElement.parentNode === document) {
        return true;
      }
      if (currentElement.parentNode instanceof DocumentFragment) {
        currentElement = (currentElement.parentNode as any).host;
      } else {
        currentElement = currentElement.parentNode;
      }
    }
    return false;
  }
}
